module.exports = "/images/heavy-vehicles.svg?d0e9ff673482385816d5d73b1478ca08";